export default __webpack_public_path__ + "static/GavulaXMas--2024-f76abca23d3200d9edf9fd029143a3aa.pdf";